export enum ProviderType {
    Email = 'email',
    Sms = 'sms',
    Push = 'push',
}